import { MemberRole, UNKNOWN_ENUM_VALUE } from '@lucidlink/dto/validation';
import { translate } from '@lucidlink/uicore';
export const getUserRoleMap = () => ({
    [MemberRole.OWNER]: translate('Owner'),
    [MemberRole.ADMIN]: translate('Admin'),
    [MemberRole.FILESPACE_ADMIN]: translate('Filespace admin'),
    [MemberRole.COLLABORATOR]: translate('Standard'),
    [MemberRole.GUEST]: translate('Guest (free)'),
    [MemberRole.SERVICE_ADMIN]: '',
    [MemberRole.SERVICE_COLLABORATOR]: '',
    [UNKNOWN_ENUM_VALUE]: translate('Unknown role'),
    CURRENT: translate('Current'),
    STANDARD_USER: translate('Standard User'),
});
